export default "__VITE_ASSET__CCyadwaE__"